/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { IconProps } from '@coursera/cds-core';
import { Tag } from '@coursera/cds-core';

import TooltipOverlay from 'bundles/grading/components/common/TooltipOverlay';

import _t from 'i18n!nls/grading';

const styles = {
  disabledTag: css`
    opacity: 0.6;
  `,
};

type Props = {
  isHidden: boolean;
  showTooltip?: boolean;
  icon?: React.ReactElement<IconProps, string>;
  disabled?: boolean;
};

const VisibilityTag = ({ isHidden, showTooltip = false, icon, disabled = false }: Props) => {
  const tag = (
    <Tag
      variant="status"
      priority={isHidden ? 'secondary' : 'primary'}
      color={isHidden ? 'default' : 'warning'}
      icon={icon}
      css={[disabled && styles.disabledTag]}
      data-testid="grade-visibility-tag"
    >
      {isHidden ? _t('HIDDEN') : _t('VISIBLE')}
    </Tag>
  );
  return showTooltip ? (
    <TooltipOverlay
      id="tooltip-grade-visibility"
      text={isHidden ? _t("Learner can't see their assignment grade") : _t('Learner can see their assignment grade')}
    >
      {tag}
    </TooltipOverlay>
  ) : (
    tag
  );
};

export default VisibilityTag;
